import React from "react";

export const VisibilityPublicIcon = () => (
    <svg width="22" height="22" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <defs>
            <linearGradient id="visibilityPublicGradient" x1="2" y1="18" x2="18" y2="2" gradientUnits="userSpaceOnUse">
                <stop stopColor="#7BD5FF" />
                <stop offset="1" stopColor="#9F8CFF" />
            </linearGradient>
        </defs>
        <path
            d="M2 10C3.5 6.5 6.5 4 10 4C13.5 4 16.5 6.5 18 10C16.5 13.5 13.5 16 10 16C6.5 16 3.5 13.5 2 10Z"
            stroke="url(#visibilityPublicGradient)"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <circle cx="10" cy="10" r="2.6" stroke="url(#visibilityPublicGradient)" strokeWidth="1.5" />
    </svg>
);

export const VisibilityFriendsIcon = () => (
    <svg width="22" height="22" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <defs>
            <linearGradient id="visibilityFriendsGradient" x1="3" y1="17" x2="17" y2="3" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FFB7A4" />
                <stop offset="1" stopColor="#FF75D8" />
            </linearGradient>
        </defs>
        <path
            d="M10 11.5C11.933 11.5 13.5 9.933 13.5 8C13.5 6.067 11.933 4.5 10 4.5C8.067 4.5 6.5 6.067 6.5 8C6.5 9.933 8.067 11.5 10 11.5Z"
            stroke="url(#visibilityFriendsGradient)"
            strokeWidth="1.5"
        />
        <path
            d="M4 15.5C5.1 13.2 7.3 12 10 12C12.7 12 14.9 13.2 16 15.5"
            stroke="url(#visibilityFriendsGradient)"
            strokeWidth="1.5"
            strokeLinecap="round"
        />
        <circle cx="4.5" cy="7.5" r="1.5" fill="rgba(255, 183, 164, 0.6)" />
        <circle cx="15.5" cy="7.5" r="1.5" fill="rgba(255, 117, 216, 0.6)" />
    </svg>
);

export const VisibilityPrivateIcon = () => (
    <svg width="22" height="22" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <defs>
            <linearGradient id="visibilityPrivateGradient" x1="4" y1="16" x2="16" y2="4" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FFD36E" />
                <stop offset="1" stopColor="#FF8E6E" />
            </linearGradient>
        </defs>
        <rect x="5" y="8" width="10" height="8" rx="2" stroke="url(#visibilityPrivateGradient)" strokeWidth="1.5" />
        <path
            d="M7 8V6.5C7 4.57 8.57 3 10.5 3C12.43 3 14 4.57 14 6.5V8"
            stroke="url(#visibilityPrivateGradient)"
            strokeWidth="1.5"
            strokeLinecap="round"
        />
        <circle cx="10" cy="12" r="1.1" fill="#FFDC9E" />
        <path d="M10 13V14" stroke="#FFDC9E" strokeLinecap="round" />
    </svg>
);

export const VISIBILITY_OPTIONS = [
    {
        value: 'Public',
        labelKey: 'home.postVisibility.public.label',
        descriptionKey: 'home.postVisibility.public.description',
        Icon: VisibilityPublicIcon,
    },
    {
        value: 'Friends',
        labelKey: 'home.postVisibility.friends.label',
        descriptionKey: 'home.postVisibility.friends.description',
        Icon: VisibilityFriendsIcon,
    },
    {
        value: 'Only me',
        labelKey: 'home.postVisibility.private.label',
        descriptionKey: 'home.postVisibility.private.description',
        Icon: VisibilityPrivateIcon,
    },
];

export const BAND_POST_VISIBILITY_OPTIONS = [
    {
        value: 'Public',
        labelKey: 'home.postVisibility.public.label',
        descriptionKey: 'home.postVisibility.public.description',
        Icon: VisibilityPublicIcon,
    },
    {
        value: 'Followers',
        labelKey: 'home.postVisibility.followers.label',
        descriptionKey: 'home.postVisibility.followers.description',
        Icon: VisibilityFriendsIcon,
    },
    {
        value: 'Private',
        labelKey: 'home.postVisibility.bandPrivate.label',
        descriptionKey: 'home.postVisibility.bandPrivate.description',
        Icon: VisibilityPrivateIcon,
    },
];

export const BAND_VISIBILITY_OPTIONS = [
    {
        value: 'PUBLIC',
        labelKey: 'home.bandTab.visibility.public.label',
        descriptionKey: 'home.bandTab.visibility.public.description',
        Icon: VisibilityPublicIcon,
    },
    {
        value: 'PRIVATE',
        labelKey: 'home.bandTab.visibility.private.label',
        descriptionKey: 'home.bandTab.visibility.private.description',
        Icon: VisibilityPrivateIcon,
    },
];

export const PROFILE_VISIBILITY_OPTIONS = [
    {
        value: 'PUBLIC',
        labelKey: 'home.profileVisibility.public.label',
        descriptionKey: 'home.profileVisibility.public.description',
        Icon: VisibilityPublicIcon,
    },
    {
        value: 'PRIVATE',
        labelKey: 'home.profileVisibility.private.label',
        descriptionKey: 'home.profileVisibility.private.description',
        Icon: VisibilityPrivateIcon,
    },
];

export const UOM_VISIBILITY_OPTIONS = [
    {
        value: 'PUBLIC',
        labelKey: 'home.postVisibility.public.label',
        descriptionKey: 'home.postVisibility.public.description',
        Icon: VisibilityPublicIcon,
    },
    {
        value: 'FRIENDS',
        labelKey: 'home.postVisibility.friends.label',
        descriptionKey: 'home.postVisibility.friends.description',
        Icon: VisibilityFriendsIcon,
    },
    {
        value: 'PRIVATE',
        labelKey: 'home.postVisibility.uomPrivate.label',
        descriptionKey: 'home.postVisibility.uomPrivate.description',
        Icon: VisibilityPrivateIcon,
    },
    {
        value: 'OWNER_ONLY',
        labelKey: 'home.postVisibility.ownerOnly.label',
        descriptionKey: 'home.postVisibility.ownerOnly.description',
        Icon: VisibilityPrivateIcon,
    },
];

/**
 * Visibility subset for event/venue forms. The forms expose one private option
 * in the picker, while edit flows preserve an existing OWNER_ONLY value until
 * the user explicitly changes visibility.
 */
export const SHAREABLE_OBJECT_VISIBILITY_OPTIONS = UOM_VISIBILITY_OPTIONS.filter(
    (option) => option.value !== 'OWNER_ONLY',
);

export const findVisibilityOption = (value, options = VISIBILITY_OPTIONS) => {
    const resolvedOptions = Array.isArray(options) && options.length > 0 ? options : VISIBILITY_OPTIONS;
    if (!value) {
        return resolvedOptions[0];
    }
    return (
        resolvedOptions.find((option) => option.value.toLowerCase() === value.toLowerCase())
        || VISIBILITY_OPTIONS.find((option) => option.value.toLowerCase() === value.toLowerCase())
        || resolvedOptions[0]
    );
};
